module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-bg-1-sp-1e6de47c549a7886bfecfc80e960c358.png";